module.exports = __webpack_public_path__ + "img/eat_out_19.fce790bc.jpg";